// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimChecklistService} from "@services";
import {from, Observable, of} from "rxjs";
import {Checklist} from "@models";

@Pipe({
	name: "getChecklistById",
	standalone: false,
})
export class GetChecklistByIdPipe implements PipeTransform {
	constructor(private _simChecklistService: SimChecklistService) {}

	transform(checklistId: string): Observable<Checklist> {
		if (!checklistId) {
			return of(null);
		}
		return from(this._simChecklistService.getChecklistById(checklistId));
	}
}
